import PropTypes from 'prop-types';
import React from 'react';
import {
  withStyles,
  Tooltip,
  Icon,
} from '@material-ui/core';
import styles from './styles';
import { formatDate } from '../../../utils/dateHelper';

export const getColorForItem = (itemList, elementId) => {
  const item = itemList.filter((i) => i.id === elementId)[0];
  return item === undefined
    ? ''
    : item.iconColor;
};

export const DueDateComponent = ({
  dueDate,
  classes,
}) => (
  <div className={classes.timeContainer}>
    <span className={classes.duration}>
      {
        dueDate !== null
          && new Date(dueDate).getTime() < new Date().getTime()
          && (
            <Tooltip title="This event is past due">
              <Icon fontSize="inherit" className={classes.dueDateIcon}>notification_important</Icon>
            </Tooltip>
          )
      }
      {
        dueDate
          ? formatDate(dueDate)
          : '-'
      }
    </span>
  </div>
);

DueDateComponent.propTypes = {
  classes: PropTypes.object,
  dueDate: PropTypes.string,
};

DueDateComponent.defaultProps = {
  classes: {},
  dueDate: null,
};

export default withStyles(styles)(DueDateComponent);
